import { SvgIcon } from "@mui/material";

const Remove = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path d="M5.5,13a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h13a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z" />
    </SvgIcon>
  );
};

export default Remove;
